export function TrancheProgress({ tranches, testid }) {
  const list = tranches || [];
  if (!list.length) return null;
  const cleared = list.filter((t) => t.cleared).length;
  const pct = Math.round((cleared / list.length) * 100);
  const color = cleared === list.length ? "bg-emerald-500" : cleared > 0 ? "bg-indigo-500" : "bg-slate-300";
  return (
    <div className="min-w-28" data-testid={testid}>
      <div className="flex justify-between text-[11px] mb-1">
        <span className={`font-semibold ${cleared === list.length ? "text-emerald-700" : "text-slate-700"}`}>{cleared}/{list.length} BG cair</span>
        <span className="text-slate-400">{pct}%</span>
      </div>
      <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
        <div className={`h-full rounded-full ${color} transition-all`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
